// extracted by mini-css-extract-plugin
export default {"Container":"logoIcon_Container__EsVt0","Image":"logoIcon_Image__nloO3"};